module.exports = __webpack_public_path__ + "img/header-weddingRingsCertificate@2x.d8aaf00.jpg";